import React, { useEffect } from 'react';
import { preloadImages } from '../../utils/preloadImages';
import './AppPreloader.css';

const AppPreloader: React.FC = () => {
  // Предзагружаем все изображения при монтировании прелоадера
  useEffect(() => {
    preloadImages();
  }, []);

  return (
    <div className="app-preloader">
      <div className="app-preloader-content">
        <div className="app-preloader-logo">
          <img src="/logo.svg" alt="A2K CRM" className="app-preloader-logo-image" />
        </div>
        <div className="app-preloader-spinner">
          <div className="app-preloader-spinner-ring"></div>
          <div className="app-preloader-spinner-ring"></div>
          <div className="app-preloader-spinner-ring"></div>
        </div>
        <p className="app-preloader-text">Загрузка...</p>
      </div>
    </div>
  );
};

export default AppPreloader;
